import { apiClient } from '../../../platform/api/apiClient';

export const eventsService = {
    getEvents(type) {
        const suffix = type ? `?type=${encodeURIComponent(type)}` : '';
        return apiClient.get(`events${suffix}`);
    },

    getEvent(eventId) {
        return apiClient.get(`events/${eventId}`);
    },

    getSharedEvent(token) {
        return apiClient.get(`events/shared/${encodeURIComponent(token)}`);
    },

    resolveSharedEvent(token) {
        return apiClient.get(`events/shared/${encodeURIComponent(token)}/resolve`);
    },

    createEvent(payload) {
        return apiClient.post('events', { json: payload });
    },

    getDashboardEvents() {
        return apiClient.get('events/dashboard-events');
    },

    getEventImages(eventId) {
        return apiClient.get(`events/${eventId}/images`);
    },

    uploadEventImages(eventId, formData) {
        return apiClient.post(`events/${eventId}/images`, { body: formData });
    },

    getEventVideos(eventId) {
        return apiClient.get(`events/${eventId}/videos`);
    },

    addEventVideo(eventId, payload) {
        return apiClient.post(`events/${eventId}/videos`, { json: payload });
    },

    deleteEventVideo(eventId, videoId) {
        return apiClient.del(`events/${eventId}/videos/${videoId}`);
    },

    reorderEventImages(eventId, orderedImageIds) {
        return apiClient.put(`events/${eventId}/images/reorder`, {
            json: { orderedImageIds }
        });
    },

    deleteEventImage(eventId, imageId) {
        return apiClient.del(`events/${eventId}/images/${imageId}`);
    },

    updateEvent(eventId, payload) {
        return apiClient.put(`events/${eventId}`, { json: payload });
    },

    deleteEvent(eventId) {
        return apiClient.del(`events/${eventId}`);
    },

    getEventShooters(eventId) {
        return apiClient.get(`events/${eventId}/shooters`);
    },

    addEventShooter(eventId, payload) {
        return apiClient.post(`events/${eventId}/shooters`, { json: payload });
    },

    removeEventShooter(eventId, eventShooterId) {
        return apiClient.del(`events/${eventId}/shooters/${eventShooterId}`);
    },

    getAvailableShooters() {
        return apiClient.get('events/available-shooters');
    },

    getOwnershipTransfers() {
        return apiClient.get('events/ownership-transfers');
    },

    getPendingOwnershipTransfer(eventId) {
        return apiClient.get(`events/${eventId}/ownership-transfer`);
    },

    requestOwnershipTransfer(eventId, payload) {
        return apiClient.post(`events/${eventId}/ownership-transfer`, { json: payload });
    },

    acceptOwnershipTransfer(transferId) {
        return apiClient.post(`events/ownership-transfers/${transferId}/accept`);
    },

    declineOwnershipTransfer(transferId) {
        return apiClient.post(`events/ownership-transfers/${transferId}/decline`);
    },

    cancelOwnershipTransfer(transferId) {
        return apiClient.post(`events/ownership-transfers/${transferId}/cancel`);
    }
};
